export const LeadStatus = Object.freeze({
  BAD: 1,
  GOOD: 2
})
